/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SubscriptionBillingFrequency {
    YEAR = 'year',
    MONTH = 'month',
}
